import React from 'react'
export const schedulesList = [
    {
        field: 'title',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'execute_at',
        headerName: 'Execute',
        valueFormatter: (p) => p.data.execute_at,
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'details',
        headerName: 'Details',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <span>{params.data.details}</span>
        },
    },
    {
        field: 'enabled',
        headerName: 'Enabled',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return params.data.enabled ? 'true' : 'false'
        },
    },
    {
        field: 'offline',
        headerName: 'Offline',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return params.data.offline ? 'true' : 'false'
        },
    },
    {
        field: 'update',
        sort: false,
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },
]

export const missionsColumns = [
    {
        field: 'number',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'status',
        headerName: 'Status',
    },
    {
        field: 'vehicle',
        headerName: 'Vehicle',
        // valueFormatter: (params) => {
        //     return params.value
        // },
        // cellRenderer: (params) => {
        //     return <span>{params.data.details}</span>
        // },
    },
    {
        field: 'created_at',
        headerName: 'Created',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'update',
        sort: false,
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },

]

export const presetsColumns = [
    {
        field: 'title',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'created_at',
        headerName: 'Created',
        sortable: true,
        unSortIcon: true,
        comparator: (valueA, valueB) => {
            const parseDate = (dateStr) => {
                if (!dateStr) return null; // Handle empty or invalid values
                const [day, month, year] = dateStr.split('/').map(Number);
                return new Date(year, month - 1, day); // Month is zero-based in JS Date
            };
    
            const dateA = parseDate(valueA);
            const dateB = parseDate(valueB);
    
            if (!dateA) return -1;
            if (!dateB) return 1;
    
            return dateA - dateB;
        },
      
    },
    {
        field: 'details',
        headerName: 'Details',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <span>{params.data.details}</span>
        },
    },
    {
        field: 'update',
        sort: false,
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },
]

export const actionsPresetsColumns = [
    {
        field: 'title',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'type',
        headerName: 'Type',
    },
    {
        field: 'details',
        headerName: 'Details',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.details}</div>
        },
    },

    {
        field: 'update',
        sort: false,
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },
]

export const definitionList = [
    {
        field: 'title',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'type',
        headerName: 'Type',
    },
    {
        field: 'description',
        headerName: 'Description',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.description}</div>
        },
    },
    {
        field: 'variables',
        headerName: 'Variables',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.variables}</div>
        },
        minWidth: 300,
    },
    {
        field: 'update',
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },
]

export const triggersColumns = [
    {
        field: 'title',
        headerName: 'Name',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'url',
        headerName: 'URL',
        tooltipField: 'url', // Show full content in a tooltip
        cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    },
    {
        field: 'action',
        headerName: 'Action',
    },
    {
        field: 'ip_whitelist',
        headerName: 'ip_whitelist',
    },
    {
        field: 'initialized',
        headerName: 'Initialized',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return params.data.initialized ? 'true' : 'false'
        },
    },

    {
        field: 'update',
        sort: false,
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.update}</div>
        },
    },
]

export const webhookList = [
    {
        field: 'url',
        headerName: 'Url',
        sortable: true,
        unSortIcon: true,
    },
    {
        field: 'actions',
        headerName: 'Actions',
    },
    {
        field: 'headers',
        headerName: 'Headers',
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.headers}</div>
        },
    },
    {
        field: 'action',
        headerName: '',
        cellClass: 'action-style d-flex justify-content-center align-items-center',
        maxWidth: 100,
        valueFormatter: (params) => {
            return params.value
        },
        cellRenderer: (params) => {
            return <div>{params.data.action}</div>
        },
    },
]
